import { t } from "@travily/i18n";
import type Participation from "@travily/types/models/MessagesParticipation";
import { ConversationFilters } from "./components/ConversationFilters";
import { ConversationListView } from "./components/ConversationListView";
import { useConversationFilters } from "./use-conversation-filters";

interface ConversationListPanelProps {
  activeConversationSqid?: string;
  participations: Participation[];
  /** Current page URL — filters live in it. Passed rather than read from Inertia so the panel
   *  renders outside it, which is what its stories do. */
  url: string;
}

export function ConversationListPanel({ activeConversationSqid, participations, url }: ConversationListPanelProps) {
  const { apply, isFiltering, kind, setKind, setUnreadOnly, unreadOnly } = useConversationFilters(url);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex flex-col gap-3 px-5 pt-6 pb-3">
        <h1 className="hidden font-extrabold text-neutral-900 text-xl tracking-tight md:block">
          {t("web.messages.index.title")}
        </h1>
        <ConversationFilters
          kind={kind}
          onKindChange={setKind}
          onUnreadOnlyChange={setUnreadOnly}
          unreadOnly={unreadOnly}
        />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-2 pb-4 md:px-3">
        <ConversationListView
          activeConversationSqid={activeConversationSqid}
          isFiltering={isFiltering}
          participations={apply(participations)}
        />
      </div>
    </div>
  );
}
